<div id="content" class="allcp-form" ng-controller="CustomerHistoryController" ng-init="setDate('All')">
    <div ng-include="'modules/customer/partials/top_menu.html'"></div>
    <header class="navbar navbar-fixed-top subnavbar bg-system">
        <ul class="nav navbar-nav navbar-left">

            <div class="form-group ml10 relative">
                <input type="text" 
                    options="checklistOpts" 
                    date-range-picker 
                    ng-model="filterData.scheduled_time"
                    class="form-control text-input btn"
                    placeholder="By Delivery Date" 
                    ng-keyup="$event.keyCode == 13 && refreshData()">
                    <label class="with-caret"></label>
            </div>

            <div class="form-group ml10">
                <select class="selectpicker"
                    multiple
                    title="By Station"
                    data-selected-text-format="count"
                    data-language="tr_TR"
                    ng-model="filterData.stations"
                    data-style="btn btn-primary" 
                    ng-keyup="$event.keyCode == 13 && refreshData()">
                    <option 
                        ng-repeat="item in data.stations track by $index" 
                        data-select-watcher 
                        data-last="{{$last}}" 
                        ng-class="filterData.stations.indexOf(item.id) === 0 ? 'selected-item' : ''"
                        value="{{item.id}}">
                        {{ item.code }} - {{ item.city }}
                    </option>
                </select>
            </div>

            <div class="form-group">
                <a href="#"
                   class="btn w50 p-2 ml10"
                   ng-show="filterData.stations.length || filterData.scheduled_time.startDate"
                   ng-click="refreshData('map')">
                    <i class="fa fa-refresh"></i>
                </a>
            </div>

            <div class="form-group"
                 ng-show="filterData.stations.length || filterData.scheduled_time.startDate">
                <a href="#" class="clear-filter ml-3" ng-click="clearCheckFilter()">
                    Clear Filter
                </a>
            </div>

            <!-- <li ng-class="{ active: selectedDate == 'All' }">
                <a href="#" class="btn btn-operation ml10" ng-click="setDate('All')">
                    All
                </a>
            </li>
            <li ng-class="{ active: selectedDate == 'Monday' }">
                <a href="#" class="btn btn-operation" ng-click="setDate('Monday')">
                    Monday
                </a>
            </li>
            <li ng-class="{ active: selectedDate == 'Tuesday' }">
                <a href="#" class="btn btn-operation" ng-click="setDate('Tuesday')">
                    Tuesday
                </a>
            </li>
            <li ng-class="{ active: selectedDate == 'Wednesday' }">
                <a href="#" class="btn btn-operation" ng-click="setDate('Wednesday')">
                    Wednesday
                </a>
            </li>
            <li ng-class="{ active: selectedDate == 'Thursday' }">
                <a href="#" class="btn btn-operation" ng-click="setDate('Thursday')">
                    Thursday
                </a>
            </li>
            <li ng-class="{ active: selectedDate == 'Friday' }">
                <a href="#" class="btn btn-operation" ng-click="setDate('Friday')">
                    Friday
                </a>
            </li>
            <li ng-class="{ active: selectedDate == 'Saturday' }">
                <a href="#" class="btn btn-operation" ng-click="setDate('Saturday')">
                    Saturday
                </a>
            </li>
            <li ng-class="{ active: selectedDate == 'Sunday' }">
                <a href="#" class="btn btn-operation" ng-click="setDate('Sunday')">
                    Sunday
                </a>
            </li> -->
        </ul>
        <div class="nav navbar-nav navbar-center"></div>
        <ul class="nav navbar-nav navbar-right">
            <!-- 
            <li class="hidden-xs" ng-if="isActive(['customer-check-orders'])">
                <a class="navbar-fullscreen toggle-active" href="/customer-check-orders">
                    <strong class="p10 fs18">Daily Check List</strong>
                </a>
            </li>
             -->
            <!-- <div class="pull-right">
                <input type="text" options="optsCheckOrder" date-range-picker ng-model="selectDate.created_at" class="btn btn-operation ml10" placeholder="By Order Date">
            </div> -->
        </ul>
    </header>
    <div class="panel-body">
        <div class="table-responsive" ng-if="data.orders.data.length > 0">
            <!-- <small class="pull-right pr10 total-record">Total Record : {{ data.orders.total }}</small>
            <br> -->
            <table class="table table-hover tc-checkbox-1 fs13">
                <thead>
                    <tr class="bg-light">
                        <th></th>
                        <th></th>
                        <th style="min-width: 150px;">Order ID</th>
                        <th>
                            Delivery
                            <a ng-click="sort('created_at','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('created_at','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                        <th>Piece</th>
                        <th>Details</th>
                        <th style="min-width: 250px;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr dir-paginate="item in data.orders.data | itemsPerPage: 250" 
                        total-items="data.orders.total" 
                        current-page="data.orders.current_page" 
                        ng-class="{'checked': selectedItems.indexOf(item.id) > -1}">
                        <td class="clickable-row">
                            <!-- <label class="option block mn" ng-if="item.status == 0 || item.status == null">
                                <input type="checkbox" ng-click="checkOrder(item.id)" ng-checked="item.check" ng-disabled="item.check" class="disable-checked" id="checkboxDefault-{{item.id}}">
                                <span class="checkbox mn"></span>
                            </label> -->
                            <label class="option block mn">
                                <input type="checkbox" ng-click="addSelectedItem(item.id)"
                                        ng-checked="selectedItems.indexOf(item.id) > -1 || master" id="checkboxDefault-{{item.id}}">
                                <span class="checkbox mn"></span>
                            </label>
                        </td>
                        <td class="clickable-row" ng-click="getOrderDetails(item)">
                            <div class="avatar-container">
                                <div class="avatar-img">
                                    {{ item.location.name.split(' ')[0][0] }}{{ item.location.name.split(' ')[1][0] }}
                                </div>
                                <div class="avatar-detail">
                                    <strong style="font-weight:bold">{{ item.location.name }}</strong>
                                    {{ item.location.email }}
                                </div>
                            </div>
                        </td>
                        <td class="clickable-row" ng-click="getOrderDetails(item)">
                            {{item.unique}}
                        </td>
                        <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.scheduled_time | amDateFormat:'MM/DD/YYYY' }}</td>
                        <td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.piece }}</td>
                        <td class="clickable-row mw200" ng-click="getOrderDetails(item)">{{ item.name | cut:true:40:' ...' }}</td>
                        
                        <td class="clickable-row mw200" ng-click="getOrderDetails(item)">
                            <div class="qr-code-container" >
                                <qrcode 
                                    class="p10"
                                    data="{{ code.code }}" 
                                    version="2" 
                                    error-correction-level="Q" 
                                    size="50" 
                                    ng-repeat="code in item.items_code">
                                </qrcode>
                            </div>
                        </td>
                        <!-- 
                    
                    <td class="clickable-row" ng-click="getOrderDetails(item)">
                        {{ item.location.address }}
                    </td>
                    <td class="clickable-row" ng-click="getOrderDetails(item)">
                        {{ item.location.address_two }}
                    </td>
                    <td class="clickable-row" ng-click="getOrderDetails(item)">
                        {{ item.location.city }}
                    </td>
                    <td class="clickable-row" ng-click="getOrderDetails(item)">
                        {{ item.location.state }}
                    </td>
                    <td class="clickable-row" ng-click="getOrderDetails(item)">
                        {{ item.location.zipcode }}
                    </td>
                    <td class="clickable-row mw200" ng-click="getOrderDetails(item)">{{ item.special_value | cut:true:40:' ...' }}</td>
                    
                     -->
                    </tr>
                </tbody>
            </table>
            <dir-pagination-controls boundary-links="true" on-page-change="getPage(newPageNumber)" template-url="dirPagination.tpl.html" class="pagination-lg pagination">
            </dir-pagination-controls>
        </div>
        <div class="text-center mt50" ng-if="data.orders.data.length == 0">
            <img src="img/empty_page_orange.svg" alt="" width="400px">
            <br>
            <h3 style="font-size: 48px;font-weight: 800;">No orders yet</h3>
        </div>
    </div>
    <div class="navbar fixed-panel-footer" ng-if="selectedItems.length">
        <div class="nav navbar-nav navbar-left">
            <a href="#" ng-click="selectAllOrderCheck(true)" class="btn mr-2 btn-outline">Select All</a>
            <a href="#" ng-click="selectAllOrderCheck(false)" class="btn btn-outline">Unselect</a>
        </div>
        <div class="nav navbar-nav navbar-center">
        </div>
        <div class="nav navbar-nav navbar-right">
            <a href="/print-checklist/{{ selectedItems }}"
            target="__BLANK"
            class="btn btn-outline">Print {{ selectedItems.length }} List</a>
        </div>
    </div>
</div>
